import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { DatePicker } from 'antd';
import dayjs from 'dayjs'
import common from '../common.module.css'

export const EndDate = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    const onChange = (date, dateString) => {
      setFieldInState({field: 'end_date', value: dateString})
    };
    
    return (
      <DatePicker 
        value={state.end_date ? dayjs(state.end_date, 'YYYY-MM-DD') : null}
        className={common.antd}
        onChange={onChange} 
        placeholder="Выберите дату окончания"  
      />
    );
}